module.exports = __webpack_public_path__ + "static/media/09.d6f1b823.jpg";